import React from "react";
import { Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { getMySubscriptionPlanId } from "../../redux/MyProfileSubscriptionSlice";

const TierPlanDetails = ({
  PlanId,
  title,
  aboutDetails,
  features,
  TandC,
  cancel,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const CancelHandler = () => {
    navigate(cancel);
  };

  const payPage = () => {
    dispatch(getMySubscriptionPlanId(PlanId));
    navigate("/my-profile/subscription/checkOutPage");
  };

  return (
    <div className="TierPlanDetails">
      <h3>{title}- About this plan</h3>
      <p>{aboutDetails}</p>
      <h3>Features</h3>
      <li>{features?.key1}</li>
      <li>{features?.key2}</li>
      <li style={{ marginBottom: "20px" }}>{features?.key3}</li>
      {/* <h3 className="T_C-Tier subs_Extra">Terms & Conditions</h3>
      <p className="subs_Extra">{TandC}</p> */}
      <h3 className="note_Head">
        Note :{" "}
        <p>
          Your change of subscription will be effective immediately. If you are
          upgrading, you will be charged prorated subscription fees for the
          remainder of this billing cycle.
        </p>
      </h3>

      <div className="TierButtons">
        <Button onClick={CancelHandler} className="TierCancel">
          Cancel
        </Button>
        <Button className="TierPay" onClick={payPage}>
          Update subscription
        </Button>
      </div>
    </div>
  );
};

export default TierPlanDetails;
